/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable max-classes-per-file */
/* eslint-disable max-len */
import { Agent, AlertConditionType, AlertRule, CreateAlertRuleParams, Entity, MetricsReportSubscription, Permission, Project, ProjectType } from '@moderepo/mode-internal-apis';
import React from 'react';
import { getSubRouteAbsolutePath, RouteGroup, SELECT_INPUT_OPTION_DIVIDER_TYPE, SlideOutCompProps } from '@moderepo/mode-app-components';
import { SlideOutPanelOptions } from '@moderepo/mode-ui-state';
import { Route } from 'react-router-dom';
import { AppProxyAPI, ModeAppProxyAPI } from '@moderepo/mode-apis';
import { AgentLogsPage } from '../agents/AgentLogsPage';
import { AgentManagePage } from '../agents/AgentManagePage';
import { DeviceLogsPage } from '../devices/DeviceLogsPage';
import { DeviceSettingsPage } from '../devices/DeviceSettingsPage';
import { HomeSettingsPage } from '../homes/HomeSettingsPage';
import { HomeLogsPage } from '../homes/HomeLogsPage';
import { MyAccountPage } from '../my-account/MyAccountPage';
import { NotAuthorized } from '../not-authorized/NotAuthorized';
import { NotFound } from '../not-found/NotFound';
import { ProjectDevicesPage } from '../projects/ProjectDevicesPage';
import { ProjectSettingsPage } from '../projects/ProjectSettingsPage';
import { UserDetailsPage } from '../users/UserDetailsPage';
import { UserLogsPage } from '../users/UserLogsPage';
import { UsersListingPage } from '../users/UsersListingPage';
import { DEFAULT_ROUTE_PATHS } from './AppRoutes';
import { RitzProjectRoute, RitzProjectRouteProps } from './RitzProjectRoute';
import { DEFAULT_SUB_ROUTE_NAME, ProjectTypeHandlersManager, ProjectTypePageLayoutHandler, ProjectTypeRoutesHandler, ProjectTypeSlideOutCompHandler,
    ProjectTypeCustomUIHandler, ProjectTypeAppProxyHandler } from '../../utils/ritzExtensionUtils';
import { integrateProjectTypeCustomUIConfigWithProjectCustomConfig, ProjectUIConfig, DeviceRegistrationWizardSettings } from '../../utils/ritzUIExtensionUtils';
import { UserInfoPreviewContainer } from '../users/UserInfoPreviewContainer';
import { HomeInfoPreviewContainer } from '../homes/HomeInfoPreviewContainer';
import { HomeKVPairInfoPreviewContainer } from '../homes/HomeKVPairInfoPreviewContainer';
import { HomeMemberInfoPreviewContainer } from '../homes/HomeMemberInfoPreviewContainer';
import { DeviceInfoPreviewContainer } from '../devices/DeviceInfoPreviewContainer';
import { DeviceKVPairInfoPreviewContainer } from '../devices/DeviceKVPairInfoPreviewContainer';
import { Layout } from '../layout/Layout';
import { TSDownloadDataRequestPreviewContainer } from '../time-series/TSDownloadDataRequestPreviewContainer';
import { TSDownloadDataRequestsListingPage } from '../time-series/TSDownloadDataRequestsListingPage';
import { HomeTSDBPage } from '../homes/HomeTSDBPage';
import { TimeSeriesInfoPreviewContainer } from '../time-series/TimeSeriesInfoPreviewContainer';
import { CollectionInfoPreviewContainer } from '../time-series/CollectionInfoPreviewContainer';
import { GenericDataViewPage } from '../time-series/GenericDataViewPage';
import { getRitzDefaultProjectUIConfig } from './defaultProjectUIConfig';
import { ProjectDashboardPage } from '../projects/ProjectDashboardPage';
import { HomeMembersPage } from '../homes/HomeMembersPage';
import { HomeDevicesPage } from '../homes/HomeDevicesPage';
import { HomeDashboardPage } from '../homes/HomeDashboardPage';
import { AlertPreviewContainer, AlertRulePreviewContainer, AlertRulesPage, AlertsPage, DashboardWidgetPreviewContainer, InvestigateAlertPage } from '..';
import { DashboardPreviewContainer, DashboardWidgetType } from '../dashboard';
import { ProjectUISettingsPage } from '../admin/ProjectUISettingsPage';
import { VideosPage } from '../videos/VideosPage';
import { HomesListingPage } from '../homes/HomesListingPage';
import { PageInfoBarContainer, PageInfoBarContainerProps } from '../misc';
import { EntitiesBrowserPage, EntityPreviewContainer, EntityDetailsPage, SelectEntityContainer, SelectEntitySubscriptionContainer }
    from '../entities';
import { ProjectDashboardSettingsPage } from '../admin/ProjectDashboardSettingsPage';
import { DownloadableDataInfo } from '../time-series/TSDownloadDataRequestManager';
import { DeviceConfigPreviewContainer } from '../devices/DeviceConfigPreviewContainer';
import { DeviceCommandSettings } from '../devices/SendDeviceCommandContainer';
import { SendDeviceCommandSlideOutContainer } from '../devices/SendDeviceCommandSlideOutContainer';
import { ProjectEntityClassesSettingsPage } from '../admin/ProjectEntityClassesSettingsPage';
import { AgentInfoPreviewContainer } from '../agents/AgentInfoPreviewContainer';
import { DeviceRegistrationWizardSlideOutContainer } from '../devices';
import { ProjectTranslationsSettingsPage } from '../admin/ProjectTranslationsSettingsPage';


/**
 * These are the list of components that can be displayed in the SlideOut panel.
 */
export enum SlideOutPanelCompType {
    USER_PREVIEW = 'user_preview',
    AGENT_PREVIEW = 'agent_preview',
    HOME_PREVIEW = 'home_preview',
    MEMBER_PREVIEW = 'member_preview',
    HOME_KV_PREVIEW = 'homeKV_preview',
    DEVICE_PREVIEW = 'device_preview',
    DEVICE_CONFIG_PREVIEW = 'device_config_preview',
    DEVICE_KV_PREVIEW = 'deviceKV_preview',
    DEVICE_REGISTRATION_WIZARD = 'device_registration_wizard',
    DOWNLOAD_TS_DATA_REQUEST = 'download_ts_Data_request',
    TIME_SERIES_PREVIEW = 'time_series_preview',
    COLLECTION_PREVIEW = 'collection_preview',
    DASHBOARD_PREVIEW = 'dashboard_preview',
    DASHBOARD_WIDGET_PREVIEW = 'dashboard_widget_preview',
    ENTITY_PREVIEW = 'entity_preview',

    // A slide out component used for selecting an entity, NOT for entity preview
    SELECT_ENTITY = 'select_entity',

    // A slide out component used for selecting a subscription, NOT for subscription preview
    SELECT_ENTITY_SUBSCRIPTION = 'select_entity_subscription',

    ALERT_RULE_PREVIEW = 'alert_rule_preview',
    ALERT_PREVIEW = 'alert_preview',

    SEND_COMMAND_TO_DEVICE = 'send_command_to_device',
}


/**
 * The options required for showing preview of a User in the Slide Out panel
 */
export interface UserPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.USER_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly userId?: number;
        };
    }
}

/**
 * The options required for showing preview of a Agent in the Slide Out panel
 */
export interface AgentPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.AGENT_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly agentId?: number;
        };
    }
}

/**
 * The options required for showing preview of a Home in the Slide Out panel
 */
export interface HomePreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.HOME_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly userId?: number | undefined;
            readonly homeId?: number;
        };
        readonly context?: {
        } | undefined;
    }
}


/**
 * The options required for showing preview of a Home Member in the Slide Out panel
 */
export interface MemberPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.MEMBER_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly homeId: number;
            readonly memberId?: number;
        };
        readonly context?: {
        } | undefined;
    }
}

/**
 * The options required for showing preview of a Home KV in the Slide Out panel
 */
export interface HomeKVPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.HOME_KV_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly homeId: number;
            readonly key?: string;
        };
        readonly context?: {
        } | undefined;
    }
}

/**
 * The options required for showing preview of a Device in the Slide Out panel
 */
export interface DevicePreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DEVICE_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly deviceId?: number;
            readonly gatewaysOnly?: boolean;    // To create/add a device that are Gateway only.
        }
        readonly context?: {
            readonly userId?: number;
            readonly homeId?: number;
        } | undefined;
    }
}

/**
 * The options required for showing preview of a Device Config in the Slide Out panel
 */
export interface DeviceConfigPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DEVICE_CONFIG_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly deviceId: number;
            readonly firmwareComponentName: string;
            readonly firmwareComponentVersionName: string;
        }
        readonly context?: {
            readonly userId?: number;
            readonly homeId?: number;
        } | undefined;
    }
}

/**
 * The options required for showing preview of a Device KV in the Slide Out panel
 */
export interface DeviceKVPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DEVICE_KV_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly deviceId: number;
            readonly key?: string;
        };
        readonly context?: {
        } | undefined;
    }
}


/**
 * The options required for showing the Device Registration Wizard Slide Out panel
 */
export interface DeviceRegistrationWizardSlideOutCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DEVICE_REGISTRATION_WIZARD;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;

            // Optional deviceId. If this is undefined, it means to use the wizard to CREATE a new device. If this is provided, it means
            // to use the wizard to EDIT an existing device
            readonly deviceId?: number | undefined;

            // Optional homeId. If homeId is provided, the home will be preselected.
            readonly preselectedHomeId?: number | undefined;

            readonly deviceRegistrationWizardSettings: DeviceRegistrationWizardSettings;
        };
    }
}



/**
 * The options required for showing Download TS Data form in the Slide Out panel
 */
export interface DownloadTSDataCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DOWNLOAD_TS_DATA_REQUEST;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly homeId: number,
            readonly tsdbSmartModuleId: string;
            readonly dataInfo: readonly DownloadableDataInfo[];
            readonly startDate: number;
            readonly endDate: number;
            readonly minDate: number;
            readonly maxDate: number;
        };
    }
}


/**
 * The options required for showing preview of a Time Series Info in the Slide Out panel
 */
export interface TimeSeriesPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.TIME_SERIES_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly homeId: number;
            readonly moduleId: string;
            readonly seriesId: string;
        };
        readonly context: {
            readonly userId?: number | undefined;
        };
    }
}


/**
 * The options required for showing preview of a Time Series Info in the Slide Out panel
 */
export interface CollectionPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.COLLECTION_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly homeId: number;
            readonly moduleId: string;
            readonly collectionId: string;
        };
        readonly context: {
            readonly userId?: number | undefined;
        };
    }
}


/**
 * The options required for showing preview of a Dashboard in the Slide Out panel
 */
export interface DashboardPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DASHBOARD_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly dashboardId?: number | undefined;
        };

        /**
         * The context of which page the user is on. Because this component can be shown in different pages, on a Project page where there is no
         * user or home context or on a User's Home page which has user and home context. This data is not required but it helps create a better
         * URL when we take the user to another page.
         */
        readonly routeContext?: {
            readonly homeId?: number | undefined;
        }
    }
}


/**
 * The options required for showing preview of a Dashboard Widget in the Slide Out panel
 */
export interface DashboardWidgetPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.DASHBOARD_WIDGET_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly dashboardId: number;

            // selectedWidget can be either a widget type of a widgetId. If the preview panel is used for creating a new widget
            // then it needs to be a widget type. If the preview panel is used for showing a widget info then it need to be a widgetId
            readonly selectedWidget: DashboardWidgetType | number;

            // The ID of the widget, type WidgetGroup, to place the new widget into. This is OPTIONAL and only for creating new widget.
            readonly widgetGroupId?: number | undefined;
        };

        /**
         * The context of which page the user is on. Because this component can be shown in different pages, on a Project page where there is no
         * user or home context or on a User's Home page which has user and home context. This data is not required but it helps create a better
         * URL when we take the user to another page.
         */
        readonly routeContext?: {
            readonly userId?: number | undefined;
            readonly homeId?: number | undefined;
        }
    }
}



/**
 * The options required for showing preview of an Entity in the Slide Out panel
 */
export interface EntityPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.ENTITY_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;

            // entityId can be an string or undefined. If an entityId is provided then the preview component will be used for showing
            // entity for for an existing entity. If the entityId is not provided then the preview component will be used for creating
            // a new entity
            readonly entityId?: string | undefined;

            // For creating a new Entity which a homeId is already provided and the user does not need to select a home
            readonly preselectedHomeId?: number | undefined;

            // For creating a new Entity which a homeId AND parentId is already provided and the user does not need to select a home or a parent
            readonly preselectedParentId?: string | undefined;
        };

        // Whether or not to show the Create Child button to allow the user creating entity child. The default is FALSE.
        readonly enableCreateChildren?: boolean | undefined;

        // Whether or not to show the Delete Entity button to allow the user. The default is FALSE.
        readonly enableDeleteEntity?: boolean | undefined;

        // Entity Preview panel has a "Show Entity Details" button and will automatically take the user to the Entity Detail page.
        // However, some time the caller doesn't want the Entity Preview panel to do it automatically and want handle it therefore
        // the caller can provide the handler if it wants to handle the button click itself.
        readonly onShowEntityDetailsHandler?: ((entity: Entity)=> void) | undefined;

        /**
         * The context of which page the user is on. Because this component can be shown in different pages, on a Project page where there is no
         * user or home context or on a User's Home page which has user and home context. This data is not required but it helps create a better
         * URL when we take the user to another page.
         */
        readonly routeContext?: {
            readonly userId?: number | undefined;
            readonly homeId?: number | undefined;
        }
    }
}



/**
 * The options required for showing the select entity input in a Slide Out panel
 */
export interface SelectEntityCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.SELECT_ENTITY;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;

            // For showing only descendant of a specific parent entity
            readonly parentId?: string | undefined;
        };
        readonly onEntitySelected: (entity: Entity)=> void;
    }
}


/**
 * The options required for showing the select entity subscription in the Slide Out panel
 */
export interface SelectEntitySubscriptionCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.SELECT_ENTITY_SUBSCRIPTION;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
        };
        readonly onSubscriptionSelected: (subscription: MetricsReportSubscription)=> void;
    }
}


/**
 * The options required for showing preview of an Alert Rule in the Slide Out panel
 */
export interface AlertRulePreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.ALERT_RULE_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;

            // targetAlertRule can be a number or AlertConditionType. If an targetAlertRule is a number then the preview component will be used
            // for showing alert rule data for for an existing alert rule. If the targetAlertRule is an AlertConditionType then the preview
            // component will be used for creating a new alert rule. If the targetAlertRule is a copy of an alert rule then the preview
            // component will also be used for creating as new alert rule.
            readonly targetAlertRule: number | AlertConditionType | CreateAlertRuleParams;
        };

        // Whether or not to show the Delete Alert Rule button to allow the user. The default is FALSE.
        readonly enableDeleteAlertRule?: boolean | undefined;
    }
}



/**
 * The options required for showing preview of an Alert in the Slide Out panel
 */
export interface AlertPreviewCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.ALERT_PREVIEW;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly alertId: string;
        };

        // To allow the caller to handle onShowEntityDetails event instead of this component
        readonly onShowEntityDetailsHandler?: ((entityId: string)=> void)|undefined;
    }
}


export interface SendCommandSlideOutCompOptions extends SlideOutPanelOptions {
    readonly compType: SlideOutPanelCompType.SEND_COMMAND_TO_DEVICE;
    readonly compProps: {
        readonly data: {
            readonly projectId: number;
            readonly deviceId: number;
            readonly predefinedCommands?: readonly (DeviceCommandSettings | SELECT_INPUT_OPTION_DIVIDER_TYPE)[] | undefined;
            readonly disableCustomCommand?: boolean | undefined;
        };
    }
}



/**
 * Type guard check to make sure the provided options is the options for UserPreviewCompOptions
 */
export const isUserPreviewCompOptions = (options: unknown): options is UserPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.USER_PREVIEW;
};

/**
 * Type guard check to make sure the provided options is the options for AgentPreviewCompOptions
 */
export const isAgentPreviewCompOptions = (options: unknown): options is AgentPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.AGENT_PREVIEW;
};



/**
 * Type guard check to make sure the provided options is the options for HomePreviewCompOptions
 */
export const isHomePreviewCompOptions = (options: unknown): options is HomePreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.HOME_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for DevicePreviewCompOptions
 */
export const isDevicePreviewCompOptions = (options: unknown): options is DevicePreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DEVICE_PREVIEW;
};

/**
 * Type guard check to make sure the provided options is the options for DeviceConfigPreviewCompOptions
 */
export const isDeviceConfigPreviewCompOptions = (options: unknown): options is DeviceConfigPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DEVICE_CONFIG_PREVIEW;
};

/**
 * Type guard check to make sure the provided options is the options for MemberPreviewCompOptions
 */
export const isMemberPreviewCompOptions = (options: unknown): options is MemberPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.MEMBER_PREVIEW;
};

/**
 * Type guard check to make sure the provided options is the options for HomeKVPreviewCompOptions
 */
export const isHomeKVPreviewCompOptions = (options: unknown): options is HomeKVPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.HOME_KV_PREVIEW;
};

/**
 * Type guard check to make sure the provided options is the options for DeviceKVPreviewCompOptions
 */
export const isDeviceKVPreviewCompOptions = (options: unknown): options is DeviceKVPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DEVICE_KV_PREVIEW;
};

/**
 * Type guard check to make sure the provided options is the options for DeviceRegistrationWizardSlideOutCompOptions
 */
export const isDeviceRegistrationWizardSlideOutCompOptions = (options: unknown): options is DeviceRegistrationWizardSlideOutCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DEVICE_REGISTRATION_WIZARD;
};

/**
 * Type guard check to make sure the provided options is the options for DownloadDataCompOptions
 */
export const isDownloadTSDataCompOptions = (options: unknown): options is DownloadTSDataCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DOWNLOAD_TS_DATA_REQUEST;
};


/**
 * Type guard check to make sure the provided options is the options for TimeSeriesPreviewCompOptions
 */
export const isTimeSeriesPreviewCompOptions = (options: unknown): options is TimeSeriesPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.TIME_SERIES_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for CollectionPreviewCompOptions
 */
export const isCollectionPreviewCompOptions = (options: unknown): options is CollectionPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.COLLECTION_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for DashboardPreviewCompOptions
 */
export const isDashboardPreviewCompOptions = (options: unknown): options is DashboardPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DASHBOARD_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for DashboardWidgetPreviewCompOptions
 */
export const isDashboardWidgetPreviewCompOptions = (options: unknown): options is DashboardWidgetPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.DASHBOARD_WIDGET_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for EntityPreviewCompOptions
 */
export const isEntityPreviewCompOptions = (options: unknown): options is EntityPreviewCompOptions => {
    return (options as SlideOutPanelOptions)?.compType === SlideOutPanelCompType.ENTITY_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for SelectEntityCompOptions
 */
export const isSelectEntityCompOptions = (options: unknown): options is SelectEntityCompOptions => {
    return (options as SelectEntityCompOptions)?.compType === SlideOutPanelCompType.SELECT_ENTITY;
};



/**
 * Type guard check to make sure the provided options is the options for SelectEntitySubscriptionCompOptions
 */
export const isSelectEntitySubscriptionCompOptions = (options: unknown): options is SelectEntitySubscriptionCompOptions => {
    return (options as SelectEntitySubscriptionCompOptions)?.compType === SlideOutPanelCompType.SELECT_ENTITY_SUBSCRIPTION;
};


/**
 * Type guard check to make sure the provided options is the options for AlertRulePreviewCompOptions
 */
export const isAlertRulePreviewCompOptions = (options: unknown): options is AlertRulePreviewCompOptions => {
    return (options as AlertRulePreviewCompOptions)?.compType === SlideOutPanelCompType.ALERT_RULE_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for AlertPreviewCompOptions
 */
export const isAlertPreviewCompOptions = (options: unknown): options is AlertPreviewCompOptions => {
    return (options as AlertPreviewCompOptions)?.compType === SlideOutPanelCompType.ALERT_PREVIEW;
};


/**
 * Type guard check to make sure the provided options is the options for SendCommandSlideOutCompOptions
 */
export const isSendCommandSlideOutCompOptions = (options: unknown): options is SendCommandSlideOutCompOptions => {
    return (options as SendCommandSlideOutCompOptions)?.compType === SlideOutPanelCompType.SEND_COMMAND_TO_DEVICE;
};



/*
 * Get the Route settings for the Home DEFAULT page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456
 *      /projects/12/users/123/homes/456
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeLandingPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.DEFAULT)}
            element={(
                <RitzProjectRoute
                    element={<HomeDashboardPage />}
                />
            )}
        />
    );
};


/*
 * Get the Route settings for the Home MEMBERS page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456/members
 *      /projects/12/users/123/homes/456/members
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeMembersPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.HOME_MEMBERS)}
            element={(
                <RitzProjectRoute
                    element={<HomeMembersPage />}
                />
            )}
        />
    );
};



/*
 * Get the Route settings for the Home devices page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456/members
 *      /projects/12/users/123/homes/456/members
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeDevicesPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.DEVICES)}
            element={(
                <RitzProjectRoute
                    element={<HomeDevicesPage />}
                />
            )}
        />
    );
};


/*
 * Get the Route settings for the Home TSDB page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456/videos
 *      /projects/12/users/123/homes/456/videos
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeTSDBPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.TSDB)}
            element={(
                <RitzProjectRoute
                    element={<HomeTSDBPage />}
                />
            )}
        />
    );
};


/*
 * Get the Route settings for the Home VIDEOS page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456/members
 *      /projects/12/users/123/homes/456/members
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeVideosPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.VIDEOS)}
            element={(
                <RitzProjectRoute
                    element={<VideosPage />}
                />
            )}
        />
    );
};


/*
 * Get the Route settings for the Home SETTINGS page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456/settings
 *      /projects/12/users/123/homes/456/settings
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeSettingsPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.SETTINGS)}
            element={(
                <RitzProjectRoute
                    element={<HomeSettingsPage />}
                />
            )}
        />
    );
};


/*
 * Get the Route settings for the Home LOGS page.
 * There are multiple Routes that show the same page. The route config is exactly the same except for the path.
 *      /projects/12/homes/456/logs
 *      /projects/12/users/123/homes/456/logs
 * So instead of copy and paste this block of <RitzProjectRoute /> in multiple places, we will call this function to create and return the HTML.
 * @param routeGroup
 */
const getHomeLogsPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.LOGS)}
            element={(
                <RitzProjectRoute
                    element={<HomeLogsPage />}
                />
            )}
        />
    );
};


/**
 * Helper function to create route component for the device Logs page. For sensor cloud project, we will be showing the SCDeviceDashboardPage.
 * This function is used for these routes
 *      /project/12/homes/34/devices/56
 *      /project/12/devices/56
 *      /project/12/user/34/homes/56/devices/78
 * @param routeGroup
 * @returns
 */
const getDeviceLogsPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.LOGS)}
            element={(
                <RitzProjectRoute
                    element={<DeviceLogsPage />}
                />
            )}
        />
    );
};


/**
 * Helper function to create route component for the device settings page.
 * This function is used for these routes
 *      /project/12/homes/34/devices/56/settings
 *      /project/12/devices/56/settings
 *      /project/12/user/34/homes/56/devices/78/settings
 * @param routeGroup
 * @returns
 */
const getDeviceLandingPageRouteComponent = (routeGroup: RouteGroup): JSX.Element => {
    return (
        <Route
            path={getSubRouteAbsolutePath(routeGroup, DEFAULT_SUB_ROUTE_NAME.SETTINGS)}
            element={(
                <RitzProjectRoute
                    element={<DeviceSettingsPage />}
                />
            )}
        />
    );
};



const getTSDBDataPageRouteComponent = (routeName: string): JSX.Element => {
    return (
        <Route
            path={routeName}
            element={(
                <RitzProjectRoute
                    element={<GenericDataViewPage />}
                />
            )}
        />
    );
};



/**
 * The handler for the default project type. This class will implement the Handler interfaces that it can handle.
 */
class DefaultProjectTypeHandler implements
    ProjectTypeSlideOutCompHandler,
    ProjectTypeRoutesHandler,
    ProjectTypePageLayoutHandler,
    ProjectTypeCustomUIHandler,
    ProjectTypeAppProxyHandler {


    /**
     * Implement the function from ProjectTypeRoutesHandler interface
     */
    public getRoutePaths (project: Project | undefined, loggedInAgent: Agent | undefined) {
        return DEFAULT_ROUTE_PATHS;
    }


    /**
     * Implement the function from ProjectTypeAppProxyHandler interface
     */
    public getAppProxyAPI (): AppProxyAPI {
        return ModeAppProxyAPI.getInstance();
    }


    public getRoutesComponent (project: Project | undefined, loggedInAgent: Agent | undefined): readonly JSX.Element[] {
        return [
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId}
                element={(
                    <RitzProjectRoute
                        element={<ProjectDashboardPage />}
                    />
                )}
            />,
            <Route
                path={getSubRouteAbsolutePath(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN as RouteGroup, DEFAULT_SUB_ROUTE_NAME.DEFAULT)}
                element={(
                    <RitzProjectRoute
                        element={<ProjectSettingsPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_MY_ACCOUNT}
                element={(
                    <RitzProjectRoute
                        element={<MyAccountPage />}
                    />
                )}
            />,
            <Route
                path={getSubRouteAbsolutePath(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN as RouteGroup, DEFAULT_SUB_ROUTE_NAME.AGENTS)}
                element={(
                    <RitzProjectRoute
                        element={<AgentManagePage />}
                    />
                )}
            />,
            <Route
                path={getSubRouteAbsolutePath(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN as RouteGroup, DEFAULT_SUB_ROUTE_NAME.AUDIT_LOGS)}
                element={(
                    <RitzProjectRoute
                        element={<AgentLogsPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_DEVICES}
                element={(
                    <RitzProjectRoute
                        element={<ProjectDevicesPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES}
                element={(
                    <RitzProjectRoute
                        element={<HomesListingPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_MANAGE_ENTITIES}
                element={(
                    <RitzProjectRoute
                        element={<EntitiesBrowserPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_VIEW_ENTITIES}
                element={(
                    <RitzProjectRoute
                        element={<EntitiesBrowserPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_MANAGE_ENTITIES_$entityId}
                element={(
                    <RitzProjectRoute
                        element={(
                            <EntityDetailsPage />
                        )}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_VIEW_ENTITIES_$entityId}
                element={(
                    <RitzProjectRoute
                        element={(
                            <EntityDetailsPage />
                        )}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ALERT_RULES}
                element={(
                    <RitzProjectRoute
                        element={<AlertRulesPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ALERTS}
                element={(
                    <RitzProjectRoute
                        element={<AlertsPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ALERTS_$alertId}
                element={(
                    <RitzProjectRoute
                        element={<InvestigateAlertPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS}
                element={(
                    <RitzProjectRoute
                        element={<UsersListingPage />}
                    />
                )}
            />,
            <Route
                path={getSubRouteAbsolutePath(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId as RouteGroup, DEFAULT_SUB_ROUTE_NAME.DEFAULT)}
                element={(
                    <RitzProjectRoute
                        element={<UserDetailsPage />}
                    />
                )}
            />,
            <Route
                path={getSubRouteAbsolutePath(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId as RouteGroup, DEFAULT_SUB_ROUTE_NAME.LOGS)}
                element={(
                    <RitzProjectRoute
                        element={<UserLogsPage />}
                    />
                )}
            />,


            // Route component for Device's landing page. For example: /projects/1310/devices/1234
            getDeviceLandingPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_DEVICES_$deviceId as RouteGroup),
            getDeviceLandingPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_DEVICES_$deviceId as RouteGroup),
            getDeviceLandingPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_DEVICES_$deviceId as RouteGroup),

            // Route component for Device's Logs page. For example: /projects/1310/devices/1234/logs
            getDeviceLogsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_DEVICES_$deviceId as RouteGroup),
            getDeviceLogsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_DEVICES_$deviceId as RouteGroup),
            getDeviceLogsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_DEVICES_$deviceId as RouteGroup),

            // Route component for Home's landing page. For example: /projects/1310/homes/1234
            getHomeLandingPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeLandingPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Home's members page. For example: /projects/1310/homes/1234/members
            getHomeMembersPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeMembersPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Home's devices page. For example: /projects/1310/homes/1234/devices
            getHomeDevicesPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeDevicesPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Home's TSDB page. For example: /projects/1310/homes/1234/tsdb
            getHomeTSDBPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeTSDBPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Home's videos page. For example: /projects/1310/homes/1234/videos
            getHomeVideosPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeVideosPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Home's settings page. For example: /projects/1310/homes/1234/settings
            getHomeSettingsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeSettingsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Home's logs page. For example: /projects/1310/homes/1234/logs
            getHomeLogsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId as RouteGroup),
            getHomeLogsPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId as RouteGroup),

            // Route component for Generic TSDB data display page. For example: /projects/1310/homes/1234/tsdb/collection_id
            getTSDBDataPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_HOMES_$homeId_TSDB_$dataId),
            getTSDBDataPageRouteComponent(DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_USERS_$userId_HOMES_$homeId_TSDB_$dataId),

            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_DOWNLOADS}
                element={(
                    <RitzProjectRoute
                        element={<TSDownloadDataRequestsListingPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_NOT_AUTHORIZED}
                element={(
                    <RitzProjectRoute
                        element={<NotAuthorized />}
                    />
                )}
            />,

            /*
                HIDDEN routes
            */
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN_UI_SETTINGS}
                element={(
                    <RitzProjectRoute
                        element={<ProjectUISettingsPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN_DASHBOARD_SETTINGS}
                element={(
                    <RitzProjectRoute
                        element={<ProjectDashboardSettingsPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN_TRANSLATIONS_SETTINGS}
                element={(
                    <RitzProjectRoute
                        element={<ProjectTranslationsSettingsPage />}
                    />
                )}
            />,
            <Route
                path={DEFAULT_ROUTE_PATHS.PROJECTS_$projectId_ADMIN_ENTITY_CLASSES_SETTINGS}
                element={(
                    <RitzProjectRoute
                        element={<ProjectEntityClassesSettingsPage />}
                    />
                )}
            />,

            <Route
                path="*"
                element={(
                    <RitzProjectRoute
                        element={<NotFound />}
                    />
                )}
            />,
        ];
    }


    /**
     * Implement the function from ProjectTypePageLayoutHandler interface
     */
    public getPageLayoutComponent (): React.FC<{}> | undefined {
        return Layout;
    }


    /**
     * Implement the function from ProjectTypePageLayoutHandler interface
     * @returns
     */
    public getPageInfoComponent (): React.FC<PageInfoBarContainerProps> {
        return PageInfoBarContainer;
    }


    /**
     * Implement the function for the ProjectTypeSlideOutCompHandler interface.
     * @param options
     */
    public getSlideOutComponent (options: SlideOutPanelOptions): React.ReactElement<SlideOutCompProps> | undefined {

        if (isUserPreviewCompOptions(options)) {
            return (
                <UserInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    userId={options.compProps.data.userId}
                />
            );
        }

        if (isAgentPreviewCompOptions(options)) {
            return (
                <AgentInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    agentId={options.compProps.data.agentId}
                />
            );
        }

        if (isHomePreviewCompOptions(options)) {
            return (
                <HomeInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    userId={options.compProps.data.userId}
                    homeId={options.compProps.data.homeId}
                />
            );
        }

        if (isMemberPreviewCompOptions(options)) {
            return (
                <HomeMemberInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    homeId={options.compProps.data.homeId}
                    memberId={options.compProps.data.memberId}
                />
            );
        }

        if (isHomeKVPreviewCompOptions(options)) {
            return (
                <HomeKVPairInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    homeId={options.compProps.data.homeId}
                    kvPairKey={options.compProps.data.key}
                />
            );
        }

        if (isDevicePreviewCompOptions(options)) {
            return (
                <DeviceInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    deviceId={options.compProps.data.deviceId}
                    gatewaysOnly={options.compProps.data.gatewaysOnly}
                    context={options.compProps.context}
                />
            );
        }

        if (isDeviceConfigPreviewCompOptions(options)) {
            return (
                <DeviceConfigPreviewContainer
                    projectId={options.compProps.data.projectId}
                    deviceId={options.compProps.data.deviceId}
                    firmwareComponentName={options.compProps.data.firmwareComponentName}
                    firmwareComponentVersionName={options.compProps.data.firmwareComponentVersionName}
                    context={options.compProps.context}
                />
            );
        }

        if (isDeviceKVPreviewCompOptions(options)) {
            return (
                <DeviceKVPairInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    deviceId={options.compProps.data.deviceId}
                    kvPairKey={options.compProps.data.key}
                />
            );
        }

        if (isDeviceRegistrationWizardSlideOutCompOptions(options)) {
            return (
                <DeviceRegistrationWizardSlideOutContainer
                    projectId={options.compProps.data.projectId}
                    deviceId={options.compProps.data.deviceId}
                    preselectedHomeId={options.compProps.data.preselectedHomeId}
                    deviceRegistrationWizardSettings={options.compProps.data.deviceRegistrationWizardSettings}
                />
            );
        }

        if (isDownloadTSDataCompOptions(options)) {
            return (
                <TSDownloadDataRequestPreviewContainer
                    projectId={options.compProps.data.projectId}
                    homeId={options.compProps.data.homeId}
                    tsdbSmartModuleId={options.compProps.data.tsdbSmartModuleId}
                    dateBounds={{
                        minDate: options.compProps.data.minDate,
                        maxDate: options.compProps.data.maxDate,
                    }}
                    startDate={options.compProps.data.startDate}
                    endDate={options.compProps.data.endDate}
                    downloadableDataInfo={options.compProps.data.dataInfo}
                />
            );
        }

        if (isTimeSeriesPreviewCompOptions(options)) {
            return (
                <TimeSeriesInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    homeId={options.compProps.data.homeId}
                    moduleId={options.compProps.data.moduleId}
                    seriesId={options.compProps.data.seriesId}
                    context={options.compProps.context}
                />
            );
        }


        if (isCollectionPreviewCompOptions(options)) {
            return (
                <CollectionInfoPreviewContainer
                    projectId={options.compProps.data.projectId}
                    homeId={options.compProps.data.homeId}
                    moduleId={options.compProps.data.moduleId}
                    collectionId={options.compProps.data.collectionId}
                    context={options.compProps.context}
                />
            );
        }


        if (isDashboardPreviewCompOptions(options)) {
            return (
                <DashboardPreviewContainer
                    projectId={options.compProps.data.projectId}
                    dashboardId={options.compProps.data.dashboardId}
                    routeContext={options.compProps.routeContext}
                />
            );
        }


        if (isDashboardWidgetPreviewCompOptions(options)) {
            return (
                <DashboardWidgetPreviewContainer
                    projectId={options.compProps.data.projectId}
                    dashboardId={options.compProps.data.dashboardId}
                    selectedWidget={options.compProps.data.selectedWidget}
                    widgetGroupId={options.compProps.data.widgetGroupId}
                    routeContext={options.compProps.routeContext}
                />
            );
        }

        if (isEntityPreviewCompOptions(options)) {
            return (
                <EntityPreviewContainer
                    projectId={options.compProps.data.projectId}
                    entityId={options.compProps.data.entityId}
                    preselectedHomeId={options.compProps.data.preselectedHomeId}
                    preselectedParentId={options.compProps.data.preselectedParentId}
                    enableCreateChildren={options.compProps.enableCreateChildren}
                    enableDeleteEntity={options.compProps.enableDeleteEntity}
                    onShowEntityDetailsHandler={options.compProps.onShowEntityDetailsHandler}
                    routeContext={options.compProps.routeContext}
                />
            );
        }

        if (isSelectEntityCompOptions(options)) {
            return (
                <SelectEntityContainer
                    projectId={options.compProps.data.projectId}
                    parentId={options.compProps.data.parentId}
                    onEntitySelected={options.compProps.onEntitySelected}
                />
            );
        }

        if (isSelectEntitySubscriptionCompOptions(options)) {
            return (
                <SelectEntitySubscriptionContainer
                    projectId={options.compProps.data.projectId}
                    onSubscriptionSelected={options.compProps.onSubscriptionSelected}
                />
            );
        }

        if (isAlertRulePreviewCompOptions(options)) {
            return (
                <AlertRulePreviewContainer
                    projectId={options.compProps.data.projectId}
                    targetAlertRule={options.compProps.data.targetAlertRule}
                    enableDeleteAlertRule={options.compProps.enableDeleteAlertRule}
                />
            );
        }

        if (isAlertPreviewCompOptions(options)) {
            return (
                <AlertPreviewContainer
                    projectId={options.compProps.data.projectId}
                    alertId={options.compProps.data.alertId}
                    onShowEntityDetailsHandler={options.compProps.onShowEntityDetailsHandler}
                />
            );
        }

        if (isSendCommandSlideOutCompOptions(options)) {
            return (
                <SendDeviceCommandSlideOutContainer
                    projectId={options.compProps.data.projectId}
                    deviceId={options.compProps.data.deviceId}
                    predefinedCommands={options.compProps.data.predefinedCommands}
                    disableCustomCommand={options.compProps.data.disableCustomCommand}
                />
            );
        }

        return undefined;
    }


    /**
     * Implement the ProjectTypeCustomUIHandler interface. Any project type that want to have custom UI needs to implement this
     * interface and implement these function.
     * @param loggedInAgent
     * @param project
     */
    public getCustomUIConfig (loggedInAgent: Agent | undefined, project: Project | undefined): ProjectUIConfig {
        return integrateProjectTypeCustomUIConfigWithProjectCustomConfig(loggedInAgent, project, getRitzDefaultProjectUIConfig(loggedInAgent, project));
    }
}

// Create an instance of the DefaultProjectTypeHandler
const defaultProjectHandler = new DefaultProjectTypeHandler();



export const initializeDefaultProjectType = () => {
    const handlersManager = ProjectTypeHandlersManager.getInstance();
    handlersManager.registerRoutesHandler(ProjectType.DEFAULT, defaultProjectHandler);
    handlersManager.registerPageLayoutHandler(ProjectType.DEFAULT, defaultProjectHandler);
    handlersManager.registerProjectCustomUIHandler(ProjectType.DEFAULT, defaultProjectHandler);
    handlersManager.registerAppProxyHandler(ProjectType.DEFAULT, defaultProjectHandler);

    // IMPORTANT: remember to register the preview handlers for all the Ritz slide out component types whenever we create
    // a new type or else it will not show up.
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.USER_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.AGENT_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.HOME_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.MEMBER_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.HOME_KV_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DEVICE_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DEVICE_KV_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DEVICE_REGISTRATION_WIZARD, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DEVICE_CONFIG_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DOWNLOAD_TS_DATA_REQUEST, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.TIME_SERIES_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.COLLECTION_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DASHBOARD_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.DASHBOARD_WIDGET_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.ENTITY_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.SELECT_ENTITY, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.SELECT_ENTITY_SUBSCRIPTION, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.ALERT_RULE_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.ALERT_PREVIEW, defaultProjectHandler);
    handlersManager.registerSlideOutComponentHandler(SlideOutPanelCompType.SEND_COMMAND_TO_DEVICE, defaultProjectHandler);
};
